/* -disable no-unused-vars */
/* -disable no-param-reassign */
/* -disable react/forbid-prop-types */
/* -disable react/require-default-props */
/* -disable react/no-unused-prop-types */
/* -disable no-useless-constructor */
/* -disable react/style-prop-object */
/* -disable eqeqeq */
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';

import {
  BodyRow,
  IconContainer,
  IconWrapper,
  StatusIndicator,
  StyledIcon,
} from './styles';

export default class TBody extends Component {
  constructor(props) {
    super(props);

    this.rowRefs = {};
  }

  _renderTableRows(rows) {
    const { hasHover, activeRow, isActive } = this.props;

    return rows.map(row => {
      if (!this.rowRefs[row.id]) {
        this.rowRefs[row.id] = React.createRef();
      }

      const selectedRow = row.nf === activeRow.nf;

      if (isActive && activeRow && selectedRow) {
        setTimeout(() => {
          this.rowRefs[row.id].current?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }, 0.1);
      }

      const hasLocation = row.hasAppPosition || row.hasTrackerPosition;

      return (
        <BodyRow
          ref={this.rowRefs[row.id]}
          hasHover={hasHover}
          status={row.status}
          active={isActive && activeRow && selectedRow}
          key={row.id}
          onClick={() => hasLocation && this.props.onRowClick(row)}
          className="Table__row"
        >
          <StatusIndicator status={row.status} />
          <td
            title={row.nf}
            className={`Table__cell ${!hasLocation && 'Row_disabled'} ${
              this.props.wrapCells && 'Table__cell-wrap'
            }`}
          >
            {row.nf}
          </td>
          <td
            title={row.nfValue}
            className={`Table__cell ${
              !hasLocation && 'Row_disabled'
            } Table__cell--align-right ${
              this.props.wrapCells && 'Table__cell-wrap'
            }`}
          >
            R$
            <FormattedNumber
              style="decimal"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={row.nfValue}
            />
          </td>
          <td
            title={row.client}
            className={`Table__cell ${!hasLocation && 'Row_disabled'} ${
              this.props.wrapCells && 'Table__cell-wrap'
            }`}
          >
            {row.client}
          </td>
          <td>
            <IconWrapper>
              <IconContainer>
                <StyledIcon active={row.hasTrackerPosition} name="truck" />
              </IconContainer>
              <IconContainer>
                <StyledIcon
                  active={row.hasAppPosition}
                  name="phone-iphone-filled"
                />
              </IconContainer>
            </IconWrapper>
          </td>
        </BodyRow>
      );
    });
  }

  render() {
    return (
      <tbody className="Table__tbody">
        {this._renderTableRows(this.props.rows)}
      </tbody>
    );
  }
}
